
import { useEffect, useState } from 'react';
import { COUPON_TYPE, DEPOSITE_TYPE, useStyles } from '../../constant/constant.js';
import { Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, Box } from '@mui/material';
import { apiBaseUrl } from '../../constant/endpoint.js';
import { axiosRequest } from '../../utility/axios.js';
import { useSelector } from 'react-redux';
import CustomizedButtons from '../../components/button/button.js';
import { type } from '@testing-library/user-event/dist/type/index.js';
import moment from 'moment';

const ViewUserInfo = () => {
    const [paymentOfferInfo, setPaymentOfferInfo] = useState({});
    const [loadingUsers, setLoadingUsers] = useState(false);
    const classes = useStyles();
    const loginSlice = useSelector(state => state.loginSlice);
    const token = loginSlice.token;

    const handleSearch = async (id) => {
        // setLoadingUsers(true);
        const url = `/paymentOffers/details?id=${id}`;
        const res = await axiosRequest("GET", url, token);

        ///user_details_bank

        if (res?.status === "success") {
            setPaymentOfferInfo(res.data[0]);
        }
        setLoadingUsers(false);
    }

    useEffect(() => {
        const path = window.location.pathname;
        const id = path.split('/')[3];
        handleSearch(id);
    }, [window.location.pathname]);

    return (
        <Box sx={{
            width: '100%', typography: 'body1', marginTop: "100px"
        }}>
           <UserBasicComponent paymentOfferInfo={paymentOfferInfo} loadingUsers={loadingUsers} classes={classes} ></UserBasicComponent>
        </Box>
    );
}

const UserBasicComponent = ({paymentOfferInfo, loadingUsers, classes}) => {
   

    const parseData = (offer) => {
        const updateDate = moment(offer.expiry_date).format('YY/MM/DD HH:mm');
        const data = {};
        data.coupon_code = offer.coupon_code;
        data.min_amount = offer.min_amount;
        data.max_cashback_amount = offer.max_cashback_amount;
        data.max_cashback_percent = offer.max_cashback_percent;
        data.usage_limit = offer.usage_limit;
        data.per_user_limit = offer.per_user_limit;
        data.expiry_date = updateDate;
        data.status = offer.status;
        data.first_deposite = offer.first_deposite;
        
        // Corrected coupon_type logic
        const couponTypeObj = COUPON_TYPE.find((type) => type.value == offer.coupon_type);
        data.coupon_type = couponTypeObj ? couponTypeObj.label : "Unknown";
    
        data.is_public = offer.is_public;

        const depositeTypeObj = DEPOSITE_TYPE.find((type) => type.value == offer.deposite_type);
        data.deposite_type = depositeTypeObj ? depositeTypeObj.label : "Unknown";
        
        return data;
    };
    
    const parsedData = parseData(paymentOfferInfo);
    
    return (
        <>
         <Typography variant="h6" gutterBottom align="center">
            Payment Offer Information
        </Typography>
        <div className='subHomeCard'>
                    <Box>
        <Table className={classes.table} >
            <TableHead>
            </TableHead>
            <TableBody>
                {loadingUsers ? (
                    <TableRow>
                        <TableCell colSpan={4}>Loading users...</TableCell>
                    </TableRow>
                ) : (
                    <>
                        <TableRow>
                            <TableCell colSpan={6}>Coupon Code:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.coupon_code}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Minimum Amount:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.min_amount}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Maximum Cashback Amount:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.max_cashback_amount}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Maximum Cashback Percent:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.max_cashback_percent}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Usage Limit:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.usage_limit}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Per User Limit:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.per_user_limit}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Expiry Date:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.expiry_date}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Status:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.status}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>First Deposite:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.first_deposite}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Coupon Type:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.coupon_type}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Is Public:</TableCell>
                            <TableCell colSpan={6}>{String(parsedData?.is_public)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={6}>Deposite Type:</TableCell>
                            <TableCell colSpan={6}>{parsedData?.deposite_type}</TableCell>
                        </TableRow>
                        {/* <TableRow>
                            <TableCell colSpan={6}>Description:</TableCell>
                            <TableCell colSpan={6}>{paymentOfferInfo?.description}</TableCell>
                        </TableRow> */}
                    </>
                )}
            </TableBody>
        </Table>
        </Box>
        </div>
        </>
       
    
    )
}

export default ViewUserInfo;
